import React from 'react';
import { Layout } from 'react-admin';
import Menu from './Menu';
import AppBar from './AppBar';
import Sidebar from './Sidebar';
import { makeStyles } from '@material-ui/core/styles';
import { EditModeProvider } from '~/hooks/useEditModeContext';
export default (props: any) => {
  const classes = useStyles();
  return (
    <EditModeProvider>
      <Layout
        classes={{ content: classes.content }}
        {...props}
        sidebar={Sidebar}
        menu={Menu}
        appBar={AppBar}
      />
    </EditModeProvider>
  );
};

const useStyles = makeStyles((theme) => ({
  content: {
    paddingRight: theme.spacing(2),
  },
}));
